module.exports = __webpack_public_path__ + "static/media/drp-delusions-of-jealousy.f23ae1eb.svg";